var map = {
	"./BRACELET.svg": 250,
	"./CLASP.svg": 251,
	"./CORRECTOR.svg": 252,
	"./CROWN.svg": 253,
	"./FOLDING_BUCKLE.svg": 254,
	"./GLASS.svg": 255,
	"./HAND.svg": 256,
	"./HANDS_SET.svg": 257,
	"./LINK.svg": 258,
	"./PIN_BUCKLE.svg": 259,
	"./PUSHER.svg": 260,
	"./SECTION.svg": 261,
	"./STRAP.svg": 262,
	"./TONGUE.svg": 263
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 249;